import DetailsTopPanel from './DetailsTopPanel';

export default DetailsTopPanel;
